import MODULE_MAPPING from '../constants/contentIDs'

//* page components
import AgencyTest from '../../src/components/page/agencyTest/agencyTestPage'
import BlogPost from '../../src/components/page/blog/blogPost/post'
import AuthorListing from '../../src/components/page/blog/listing/authorsListing'
import CategoryListing from '../../src/components/page/blog/listing/categoryListing'
import CollectionListing from '../../src/components/page/blog/listing/collectionListing'
import MainBlog from '../../src/components/page/blog/mainBlogLanding'
import Career from '../../src/components/page/careers/about'
import Events from '../../src/components/page/events/events'
import FormFlex from '../../src/components/page/formFlex/formFlexPage'
import HomePage from '../../src/components/page/home/homePage'
import LegalPage from '../../src/components/page/legal/legalPage'
import BusinessPartners from '../../src/components/page/partners/businessPartners/business-partners'
import ServicePartners from '../../src/components/page/partners/servicePartners/service-partners'
import PartnerPost from '../../src/components/page/partners/partnerPost/partnerPost'
import PublicSectorPartners from '../../src/components/page/partners/publicSectorPartners/public-sector-partners'
import TechnologyPartners from '../../src/components/page/partners/technologyPartners/technology-partners'
import PDF from '../../src/components/page/pdf/pdfPage'
import ProductDownload from '../../src/components/page/product/download/productDownload'
import ProductPage from '../../src/components/page/product/productPage'
import RawHTML from '../../src/components/page/rawHTML/rawHTMLPage'
import ResourceDemo from '../../src/components/page/resourceDemo/resourceDemoPage'
import AnalystReport from '../../src/components/page/resources/analystReport/analystReport'
import CompanyListing from '../../src/components/page/resources/company/companyListing/companyListing'
import NewsroomPost from '../../src/components/page/resources/company/newsroomPost/newsroomPost'
import CaseStudy from '../../src/components/page/resources/customerStory/customerStory'
import ResourceListing from '../../src/components/page/resources/listing/listing'
import Webinar from '../../src/components/page/resources/webinar/webinar'
import WebinarRecording from '../../src/components/page/resources/webinar/webinarRecording/webinarRecording'
import WhitePaper from '../../src/components/page/resources/whitePaper/whitePaper'
import ThankYou from '../../src/components/page/thankYou/thankYouPage'

export const getTemplate = (contentType: string) => {
  const productTemplate = [
    MODULE_MAPPING.PAGE_SOLUTIONS,
    MODULE_MAPPING.PAGE_FLEX,
    MODULE_MAPPING.PAGE_PRODUCT,
    MODULE_MAPPING.PAGE_ABOUT_RPA,
  ]

  if (productTemplate.includes(contentType)) return ProductPage

  const mapping = [
    [MODULE_MAPPING.HOMEPAGE, HomePage],
    [MODULE_MAPPING.PAGE_ANALYST_REPORT, AnalystReport],
    [MODULE_MAPPING.PAGE_WHITEPAPER, WhitePaper],
    [MODULE_MAPPING.PAGE_PLACEHOLDER, Webinar],
    [MODULE_MAPPING.PAGE_PDF, PDF],
    [MODULE_MAPPING.PAGE_PARTNER_POST, PartnerPost],
    [MODULE_MAPPING.PAGE_CAREER, Career],
    [MODULE_MAPPING.PAGE_DOWNLOAD, ProductDownload],
    [MODULE_MAPPING.PAGE_BUSINESS_PARTNERS, BusinessPartners],
    [MODULE_MAPPING.PAGE_SERVICE_PARTNERS, ServicePartners],
    [MODULE_MAPPING.PAGE_TECHNOLOGY_ALLIANCES, TechnologyPartners],
    [MODULE_MAPPING.PAGE_PUBLIC_SECTOR_PARTNERS, PublicSectorPartners],
    [MODULE_MAPPING.PAGE_RESOURCE, CaseStudy],
    [MODULE_MAPPING.PAGE_RESOURCE_DEMO, ResourceDemo],
    [MODULE_MAPPING.PAGE_WEBINAR_RECORDING, WebinarRecording],
    [MODULE_MAPPING.PAGE_THANK_YOU, ThankYou],
    [MODULE_MAPPING.PAGE_LEGAL, LegalPage],
    [MODULE_MAPPING.PAGE_NEWSROOM_ARTICLE, NewsroomPost],
    [MODULE_MAPPING.PAGE_BLOG_POST, BlogPost],
    [MODULE_MAPPING.PAGE_SECONDARY_BLOG_POST, BlogPost],
    [MODULE_MAPPING.PAGE_MAIN_BLOG, MainBlog],
    [MODULE_MAPPING.PAGE_BLOG_AUTHOR_LISTING, AuthorListing],
    [MODULE_MAPPING.PAGE_BLOG_CATEGORY_LISTING, CategoryListing],
    [MODULE_MAPPING.PAGE_BLOG_COLLECTION_LISTING, CollectionListing],
    [MODULE_MAPPING.PAGE_COMPANY_LISTING, CompanyListing],
    [MODULE_MAPPING.PAGE_RESOURCE_LISTING, ResourceListing],
    [MODULE_MAPPING.PAGE_FORM_FLEX, FormFlex],
    [MODULE_MAPPING.PAGE_EVENTS, Events],
    [MODULE_MAPPING.PAGE_RAW_HTML, RawHTML],
    [MODULE_MAPPING.PAGE_AGENCY_TEST, AgencyTest],
  ]

  for (const duple of mapping) {
    if (contentType === duple[0]) return duple[1]
  }

  return null
}
